import {
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
  MODAL_INTERACTION,
} from '../actions/constants';
import { MODAL_HIDDEN_COLUMNS } from '../util/enums/EnumModals';
import ModalHiddenColumns from '../components/modals/ModalHiddenColumns';
import TableColumns from '../util/TableColumns';
import HiddenColumn from '../util/HiddenColumn';

const INITIAL_STATE = {
  nodes: {}, // tree of name => { hidden, nodes } nodes
  hideSQLEditor: false,
  readyForSave: true,
  saving: false,
};

function sortFunction(ta, tb) {
  const a = ta.tableRef();
  const b = tb.tableRef();
  if (a.schema() < b.schema()) {
    return -1;
  }
  if (a.schema() > b.schema()) {
    return 1;
  }
  if (a.name() < b.name()) {
    return -1;
  }
  if (a.name() > b.name()) {
    return 1;
  }
  return 0;
}

const modalHiddenColumns = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED: {
      if (action.payload.modal === ModalHiddenColumns) {
        const hiddenColumns = action.payload.json._hiddenColumns.map((hc) =>
          HiddenColumn.build(hc),
        );
        const tableColumns = action.payload.json._tableColumns
          .map((tc) => TableColumns.buildFromServer(tc))
          .sort(sortFunction);
        const nodes = {};
        tableColumns.forEach((tc) => {
          const schema = tc.tableRef().schema();
          if (!nodes[schema]) {
            nodes[schema] = {
              hidden: false,
              expanded: true,
              nodes: {},
            };
          }
          const tableName = tc.tableRef().name();
          nodes[schema].nodes[tableName] = {
            hidden: false,
            expanded: false,
            nodes: {},
          };
          tc.columns().forEach((c) => {
            nodes[schema].nodes[tableName].nodes[c] = {
              hidden: false,
            };
          });
        });
        hiddenColumns.forEach((hc) => {
          if (!nodes[hc.schema()]) {
            return; // schema no longer exists, so skip
          }
          if (hc.column()) {
            if (!nodes[hc.schema()].nodes[hc.table()]) {
              return; // table no longer exists, so skip
            }
            if (!nodes[hc.schema()].nodes[hc.table()].nodes[hc.column()]) {
              return; // column no longer exists, so skip
            }
            nodes[hc.schema()].nodes[hc.table()].nodes[
              hc.column()
            ].hidden = true;
            nodes[hc.schema()].nodes[hc.table()].expanded = true; // expand table to show hidden columns
          } else if (hc.table()) {
            if (!nodes[hc.schema()].nodes[hc.table()]) {
              return; // table no longer exists, so skip
            }
            nodes[hc.schema()].nodes[hc.table()].hidden = true;
          } else {
            nodes[hc.schema()].hidden = true;
          }
        });
        return {
          ...state,
          nodes,
          hideSQLEditor: action.payload.json._hideSqlEditor,
        };
      }
      return state;
    }
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== MODAL_HIDDEN_COLUMNS) {
        return state;
      }
      const { props } = action.payload;
      switch (props.section) {
        case 'toggle-sql-editor':
          return { ...state, hideSQLEditor: !state.hideSQLEditor };
        case 'saving':
          return { ...state, saving: true, readyForSave: false };
        case 'show-all':
        case 'hide-all': {
          const hidden = props.section === 'hide-all';
          const nodes = { ...state.nodes }; // take copy
          if (props.column) {
            // do nothing
          } else if (props.table) {
            Object.keys(nodes[props.schema].nodes[props.table].nodes).forEach(
              (column) => {
                nodes[props.schema].nodes[props.table].nodes[column].hidden =
                  hidden;
              },
            );
          } else {
            Object.keys(nodes[props.schema].nodes).forEach((table) => {
              nodes[props.schema].nodes[table].hidden = hidden;
            });
          }
          return { ...state, nodes };
        }
        case 'toggle-expanded': {
          const nodes = { ...state.nodes }; // take copy
          if (props.column) {
            // do nothing
          } else if (props.table) {
            nodes[props.schema].nodes[props.table].expanded =
              !nodes[props.schema].nodes[props.table].expanded; // toggle table expanded
          } else {
            nodes[props.schema].expanded = !nodes[props.schema].expanded; // toggle schema expanded
          }
          return { ...state, nodes };
        }
        case 'toggle-hidden': {
          const nodes = { ...state.nodes }; // take copy
          if (props.column) {
            nodes[props.schema].nodes[props.table].nodes[props.column].hidden =
              !nodes[props.schema].nodes[props.table].nodes[props.column]
                .hidden; // toggle column hidden
          } else if (props.table) {
            nodes[props.schema].nodes[props.table].hidden =
              !nodes[props.schema].nodes[props.table].hidden; // toggle table hidden
          } else {
            nodes[props.schema].hidden = !nodes[props.schema].hidden; // toggle schema hidden
          }
          return { ...state, nodes };
        }
        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default modalHiddenColumns;
